import { debounce } from "../utilities/_throttleDebounce"
import { launchConfetti } from './_confetti';

export default function congratulationsModalController() {
    return {
        isOpen: false, // Initially closed
        hasShown: false, // Track if we've shown the congratulations modal in this session
        fireworksLaunched: false, // Track if fireworks have been launched

        // Methods to control the modal
        open() {
						const self = this

            this.isOpen = true;
            this.hasShown = true;

            // Save to localStorage that we've shown the modal
            localStorage.setItem('congratulationsModalShown', 'true');

            // Launch fireworks confetti animation if not already launched
            if (!this.fireworksLaunched) {
                // Short delay to ensure modal is visible before fireworks
                setTimeout(() => {
                    launchConfetti();
                }, 300);
                this.fireworksLaunched = true;
            }

            // Disable scrolling when modal is open
            document.documentElement.style.overflow = 'hidden';

						// Calulate overlay height
						//
						setTimeout(function() {
							self.calculateOverlayHeight()
						}, 100)
        },

        close() {
            this.isOpen = false;

            // Re-enable scrolling when modal is closed
            document.documentElement.style.overflow = '';
        },

				reset()	{
						this.$store.tracker.clear();
						this.$store.completion.clear();
						this.close();
						localStorage.removeItem('introModalSeen');
						localStorage.removeItem('congratulationsModalShown');

						setTimeout(() => {
							location.reload()
						}, 250);
				},

				calculateOverlayHeight() {
						this.$refs.congratulationsModalOverlay.style.height = ''

						if (this.$refs.congratulationsModal.scrollHeight > this.$refs.congratulationsModal.clientHeight) {
								this.$refs.congratulationsModalOverlay.style.height = this.$refs.congratulationsModal.scrollHeight + 'px'
						} else {
								this.$refs.congratulationsModalOverlay.style.height = this.$refs.congratulationsModal.clientHeight + 'px'
						}
				},

        init() {
						const self = this

            // Check localStorage to see if we've shown the modal before
            this.hasShown = localStorage.getItem('congratulationsModalShown') === 'true';

            // Listen for completion store updates
            this.$watch('$store.completion.isComplete', (isComplete) => {
							if (isComplete && !this.hasShown) {
								// Only show if complete and not shown before and add delay so last item can be viewed briefly first
								//

								setTimeout(() => {
									this.open();
								}, 2000);
							}
            })

            // Listen for manual open requests
            this.$watch('$store.congratulationsModal.requestOpen', (value) => {
							if (value) {
								this.open()

								// Reset the flag
								this.$store.congratulationsModal.requestOpen = false
							}
            })

						// Handle modal overlay
						//
						window.addEventListener('resize', debounce(function() {
							self.calculateOverlayHeight()
						}, 100))
        }
    };
}
